export default "__VITE_ASSET__BpncbV4n__"